import React, { useState } from "react";
import { Input, List } from "semantic-ui-react";

const SearchableList = ({ items }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredItems = items.filter((item) =>
    item.key.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div>
      <Input
        icon="search"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        fluid
        style={{
          borderRadius: "0.4rem",
        }}
      />
      <List
        selection
        animated
        style={{
          maxHeight: "25rem",
          overflowY: "auto",
          marginBottom: "1rem",
        }}
      >
        {filteredItems.map((item, index) => (
          <List.Item
            key={index}
            style={{
              padding: "0.8rem",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
          >
            {item}
          </List.Item>
        ))}
      </List>
    </div>
  );
};

export default SearchableList;
